import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Dialog } from '@material-ui/core';
import PropTypes from 'prop-types';
import DialogActions from '../DialogActions';
import DialogContent from '../DialogContent';
import DialogTitle from '../DialogTitle';
import MainButton from '../../MUI/MainButton';
import TitleTypography from '../../MUI/TitleTypography';
import { handleMobileInputChange } from '../../../containers/MakeRecurringPaymentContainer/steps/RecurringPaymentScheduleStep/CustomCells';
import MainTextField from '../../MUI/MainTextField';

import useStyles from './makeStyles';

const ChangePayableDialog = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    open,
    setOpen,
    editableColumn,
    editableRow,
    handleUpdate,
    inputValue,
    setInputValue,
    setEditableRow,
  } = props;

  const { title } = editableColumn;
  const { payable } = editableRow;

  useEffect(() => {
    if (open) {
      setInputValue(payable);
    }
  }, [payable, open, setInputValue]);

  return (
    <Dialog
      fullWidth
      onClick={(e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }}
      onClose={() => setOpen(false)}
      classes={{ paper: classes.dialogPaper }}
      className={classes.root}
      open={open}
    >
      <DialogTitle>
        <TitleTypography className={classes.dialogTitle}>
          <Trans i18nKey={title} />
        </TitleTypography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <MainTextField
          size="small"
          type="tel"
          variant="outlined"
          label={t('recurrPayment.cols.amount')}
          value={inputValue}
          onChange={(evt) => handleMobileInputChange(evt.target.value, editableRow, setInputValue)}
          onClick={(e) => {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
          }}
          fullWidth
        />
      </DialogContent>
      <DialogActions className={classes.actions}>
        <MainButton
          width="fullWidth"
          variant="contained"
          onClick={() => {
            handleUpdate();
            setOpen(false);
            setEditableRow({});
          }}
          color="primary"
        >
          {t('leaveWarningModal.confirm')}
        </MainButton>
        <MainButton
          width="fullWidth"
          variant="outlined"
          color="primary"
          onClick={() => {
            setOpen(false);
            setEditableRow({});
          }}
        >
          {t('leaveWarningModal.cancel')}
        </MainButton>
      </DialogActions>
    </Dialog>
  );
};

ChangePayableDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  editableColumn: PropTypes.shape({
    title: PropTypes.string,
  }),
  editableRow: PropTypes.shape({
    payable: PropTypes.number,
  }),
  handleUpdate: PropTypes.func,
  inputValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setInputValue: PropTypes.func,
  setEditableRow: PropTypes.func,
};

ChangePayableDialog.defaultProps = {
  open: false,
  setOpen: () => {},
  editableColumn: {},
  editableRow: {},
  handleUpdate: () => {},
  inputValue: '',
  setInputValue: () => {},
  setEditableRow: () => {},
};

export default ChangePayableDialog;
